<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        Text Search
        <div class="page__header-subtitle">
          All management wrt text search feature
        </div>
      </div>
    </div>

    <div class="page__body">
      <div class="card text-white">
        <div class="card-body bg-black">
          <div class="mb-3 d-flex">
            <div v-if="syncing" class="sync-loading">
              <b-spinner small></b-spinner>
            </div>
            <div v-else class="sync-button" @click="syncTextSearch">
              <b-icon icon="arrow-repeat" scale="1"></b-icon>
            </div>
            <div><span class="text-secondary">System Status:</span> {{systemStatus}} <br></div>
          </div>
          <div class="mb-3">
            <div class="search-bar-container my-2 my-lg-3 mr-2 mr-lg-4" v-click-outside="closeSearch">
              <div class="search-bar mb-0">
                <input class="w-100 pl-3" ref="textSearchInputRef" type="text" v-model="searchText" @keyup="autocompleteText"/>
                <div class="search-input" @click="searchText = ''">X</div>
                <b-list-group v-if="searchBarActive">
                  <b-list-group-item v-if="searchText && searchResults && searchResults.length > 0" v-for="result in searchResults" v-bind:value="result.title">
                    <label class="ef-cursor-pointer" @click="onSearchResultSelected(result)">{{result.title }}</label>
<!--                    <div class="locked-cover ef-cursor-pointer"-->
<!--                         v-if="result.isLocked"-->
<!--                         v-b-tooltip.hover-->
<!--                         :title="lockedMessage(result.lockedType)">-->
<!--                      <b-icon class="lock-icon" icon="lock"></b-icon>-->
<!--                    </div>-->
                  </b-list-group-item>
                </b-list-group>
                <div class="search-icon-close ef-cursor-pointer" @click="autocompleteText">
                  <b-icon icon="search" scale="1"></b-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import textSearch from "@/module_admin/api/text-search";
function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export default {
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // Check that the clicked element is not within the menu container
          if (!(el === event.target || el.contains(event.target))) {
            // Call the specified method
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  data() {
    return {
      systemStatus: 'unknown',
      searchBarActive: true,
      searchText: '',
      searchResults: [],
      syncing: false,
    }
  },
  methods: {
    closeSearch() {
      this.searchBarActive = false;
    },
    syncTextSearch() {
      this.syncing = true;
      textSearch.sync().finally(_ => this.syncing = false)
    },
    autocompleteText: debounce(function() {
      textSearch.search(this.searchText)
          .then(searchResults => {
            this.searchResults = searchResults.map(result => {
              return {
                id: result.id,
                title: result.title,
                category: result.category,
                tenantId: result.tenant_id,
                tenantName: result.tenant_name,
                isLocked: result.isLocked,
                lockedType: result.lockedType
              }
            });
            this.searchBarActive = true;
          })
    }, 100), // Set the desired throttle time in milliseconds
    onSearchResultSelected(result) {
      console.log(result);
    },
    lockedMessage(lockedType) {
      if (lockedType === 'corporate-subs-user-only')
        return `For subscribed trainers only.
        Contact your trainer to unlock more videos.`
      else
        return `For corporate only.
        Click to enter your access code to unlock more videos.`
    },
  },
  mounted() {
    textSearch.isTextSearchActive().then(data => {
      this.systemStatus = "active";
    }).catch(error => {
      console.error(error);
      this.systemStatus = "inactive";
    })
  }
}
</script>
<style lang="scss" scoped>
.sync-loading, .sync-button {
  padding: 0 8px;
  margin-right: 16px;
  border-radius: 12px;
}
.sync-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sync-button {
  background-color: #73bc44;
  cursor: pointer;
}
.search-bar-container {
  z-index: 9999 !important;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .search-bar {
    display: flex;
    color: black;
    position: relative;
    width: 75%;
  }

  .search-open .form-group {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search-open .form-control {
    height: 45px;
    width: 250px;
  }

  .list-group {
    // top: -21px;
    position: absolute;
    max-width: 100%;
    left: 0px;
    right: auto;
    top: 45px;
    bottom: auto;
    z-index: 99;
  }

  .search-input {
    position: absolute;
    right: 45px;
    top: 12px;
    height: 25px;
    width: 25px;
    font-size: 16px;
    font-weight: 600;
    color: #73bc44;
    cursor: pointer;
  }

  .search-icon-close {
    height: 45px;
    width: 45px;
    min-width: 45px;
    background-color: #73bc44;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 20px;
    border-radius: 0 100px 100px 0 !important;
  }

  .locked-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);;
    pointer-events: all;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;

    .lock-icon {
      font-size: 200%;
    }
  }
}

</style>